import apiClient from './Api';
const PREFIX = '/invgroups';

// GROUP APIS
const getInvGroups = () => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'GET'
  });
};

const getInvGroupDetails = postData => {
  return apiClient({
    url: `${PREFIX}/details`,
    method: 'POST',
    data: postData
  });
};

const saveInvGroup = postData => {
  return apiClient({
    url: `${PREFIX}/save`,
    method: 'POST',
    data: postData
  });
};

const deleteInvGroup = postData => {
  return apiClient({
    url: `${PREFIX}/delete`,
    method: 'POST',
    data: postData
  });
};

const InvGroupService = { getInvGroups, getInvGroupDetails, saveInvGroup, deleteInvGroup };
export default InvGroupService;
